export default {
  strings: state => state.strings,
};
